import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { SEND_COPY } from '../../sendOrchestration.constants';
import {
  cardStyles,
  cardTitleStyles,
  summaryLabelStyles,
  summaryRowsStyles,
  summaryRowStyles,
} from '../../SendStep.styles';
import { SendStepTestIds } from '../../SendStep.testIds';

const SendSummaryCard = ({ rows }) => (
  <Box data-testid={SendStepTestIds.SUMMARY} sx={cardStyles}>
    <Typography sx={cardTitleStyles} variant="bold12">
      {SEND_COPY.summaryTitle}
    </Typography>
    <Box sx={summaryRowsStyles}>
      {rows.map(({ label, value }) => (
        <Box key={label} sx={summaryRowStyles}>
          <Typography sx={summaryLabelStyles} variant="regular12">
            {label}
          </Typography>
          <Typography variant="bold12">{value}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

SendSummaryCard.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node.isRequired,
    }),
  ).isRequired,
};

export default memo(SendSummaryCard);
